export default [
    {
        path: '/forgot-password',
        name: 'forgot-password',
        component: () => import('@/views/forgotPassword/index.vue'),
        meta: {
            layout: 'full',
        },
    },
]